import SkillCategory from "./SkillCategory";

export default SkillCategory;